<ng-container>
	<video #video [poster]="" [ngStyle]="style" [src]="hackSrc" controls preload="auto"></video>
</ng-container>
